interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let index = 1; index <= totalPages; index += 1) {
    pages.push(index);
  }

  const visiblePages = pages.filter(
    (item) => item === 1 || item === totalPages || Math.abs(item - page) <= 1,
  );

  return (
    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page <= 1}
        className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-3 py-2 text-sm text-foreground-700 transition hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {visiblePages.map((item, index) => {
        const prev = visiblePages[index - 1];
        const showEllipsis = prev && item - prev > 1;
        return (
          <span key={item} className="flex items-center gap-2">
            {showEllipsis && <span className="px-1 text-foreground-400">…</span>}
            <button
              type="button"
              onClick={() => onChange(item)}
              aria-current={item === page ? "page" : undefined}
              className={`flex h-9 w-9 items-center justify-center rounded-md text-sm font-medium transition ${
                item === page
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {item}
            </button>
          </span>
        );
      })}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page >= totalPages}
        className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-3 py-2 text-sm text-foreground-700 transition hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}